import httpAjax from './http.js'
/* eslint-disable */
// eslint-disable-next-line
let icon = new T.Icon({
  iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAFQUlEQVRIia2WWWxUVRjHf+fOdKaztdIWkEJbFqlRMLgQEfDBRF+MTUw0mqjBwIMk+qSCS1weMCYa2eKbASJEIzG8iAQxwUQIgpGYIG6gBVKK006htHSZttPZjvnuPbe9c5mBIv6TLznLt5/vfOcovXMb14ACHkQX2+i9dC9jozNt1kj0ItNnnEBZ+4Gjas1aXUmF0rsqGniIVPeHnGtfRv9lGB2FXM7ZqaqCaBTqGmBB63FmNb6pVq89XN7AZ9v9awEKxY/4+cdX6OxQpIehUCjvQiAA8QS0zNPcv2ILlvWGev6FEmYLpfCQIju+k8MHX6X9tCI9BGgIWOVJ9oTnzGnFoYPrRFZ/vkOVGrAUHlrP8aOrSCWhmK+s2E+FPLaMyFpqXaUIWjj16wZ6kkABgtaNkciI7Onf3tO7P225OoJi4WW6OiMUclP3/KpIcpA8H7F1+Qwokh1Pkx6EgLpx710S2ZEhSHY8pffsss8iaKcH7mKgv9GuFqmMm0E+DwP9s1FqEfBH0I4AWsiPS4HaQd00RJel5nkNzISiOaz/AaLSUvVOihwDfYTDEAyArnjrpwZJudxyS3U4BmxzfMfMxmEudiUYz9ycgWgcGpvOgzrmraI081rX0zQXqsNONfwXEtnmuZrG5pfU48/lTRVN2N7GfSubCATeIXUBMmNTT5ekJVwNs5phybINqu3Zb90tt0xdvMs9y/9iWv1WLpydzmC/U3bXQrAKauugecFl5ra+rR57pqQ9K33gy3LS9YwMbeLUidX0piCXLW8hGIQZs2HR0k+Ixl/PHtg6fBULqqxoH/GaNdy9vJdfjr1mGyn6WrZEPq0BFi/dkT20/cVKMfpTNIHs/i1xQpEdoSVtjzI2sthuI15EYtCysCt38puPgTiQLm/AKjWQ3bdZ7nOTnabsGIXh1PuB+oYvyAwHSg69roFiSG/UV7rDwO1AP3DBaauTKHlwsvs2C/MdtnKD4vmTndROK9j5tiyH5Mmsa8gWfv/+uEdXnZEN+ww4Vzv79aYqoNXPoDPpGh2JdlIdmXyYqiPoaLRTZ9IJX0bCRkfVpAEU2b2bxMx8IORhlvEK4GFNro9YwmklQrEEmnwf8Ijh8cvNNx3JRAAN5qBcVItiYI4dRV8ySaImR6jKoURNzl5zMMfwVnvk40YnVvarjWJiVknaYCUwEX6xu72XeK2mOqpsitdqe20SCSPjbceiU8lCrTdnwG3eQ5aK0mPpVUWrGNLReFBHY0F7PJZeZarNRb2RdSE6a10DLiSahZ65VMYTErIevATRGMTi2GMnDU8aHhcL3dwb2AZi3gXffKVbVcX+FDocRodC9thXCC5iPodjQV8F1FCKBe5MD/WiRwYmxr6U4tMx4DoQ9B1M0DeeNJ7NoAcvTow9COG85oUyOqyg2XAXvZLSp0e8KdMDJZ67GPG1B6+Ogng/7lkYKJXlb+9EZ0ZsuhaPT8e4ZTxwMQpc8czlXZ3s8bro0CSGDY+LK0bHRHTWdbweA3YD3X63zdpuw1MxGqWP7CW754M7pcN7Nh4Amn3McjNvNeMeIOXbl1b9k8+5U4G3Yvb3Jee7MCnTS7x3Im0U95R5XHqMcu8vQQxm3BIdMA+GC6mKI8CfppoqIW94fvBVUr+bem/Ndppb63pdNMJnTbqmy7fKrEv4l4F/fGWJKZpOd+I1IILtgHxab/GsSxmfMXQ9iNcdRpcN/29XNs4BSS/TFCC8XUa2RM4bgRfSE+TFmmEOv+QZ9UUn+Zb2WvasKhkQiIDUupD0Gylj4ZdKkZ+YS5UB/AvTksaLt+NbPgAAAABJRU5ErkJggg==',
  // eslint-disable-next-line
  iconSize: new T.Point(24, 42),
  // eslint-disable-next-line
  iconAnchor: new T.Point(20, 20)
})
// console.log(JSON.parse(pub.decode(route)))
/*if (that.params.cityId) {

} else {
}*/
$(function () {
  // mapinit(102.55879281894, 31.121115892911, 6)
})



let pointdata = []
// 地图上显示点位
function ShowSearchPoint(data, addressBool) {
  if (addressBool) {
    // eslint-disable-next-line
    pointdata = []
  }
  if(MAP.infoWin){MAP.map.removeOverLay(MAP.infoWin)}
  if(MAP.Marker){MAP.map.removeOverLay(MAP.Marker)}
  if(MAP.MarkerClusterer!=null)
  {
    MAP.MarkerClusterer.clearMarkers()
  }

  let zoomArr = []
  let arrayObj = []
  // var $newhtml = ''
  for (let i = 0; i < data.length; i++) {
    var x = parseFloat(data[i].x)
    var y = parseFloat(data[i].y)

    zoomArr.push(new T.LngLat(x, y));
    // 聚合
    let marker = new T.Marker(new T.LngLat(x, y), {
      title: data[i].name,
      icon: icon
    })
    marker.id = 'namesearch_' + data[i].id
    marker.pointId = data[i].id
    marker.attributes = data[i]
    marker.addEventListener('click', overlay_style)
    marker.addEventListener('mouseover', Mark_Mouseover)
    marker.addEventListener('mouseout', Mark_Mouseout)
    arrayObj.push(marker)
  }

    // eslint-disable-next-line
    MAP.MarkerClusterer = new T.MarkerClusterer(MAP.map, {
      markers: arrayObj
    })

   MAP.MarkerClusterer.setStyles([{
    url: 'data:image/png;base64,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',
    size: [52, 52], // 图片大小
    // eslint-disable-next-line
    offset: new T.Point(-15, -13), // 显示图片的偏移量
    textColor: '#fff', // 显示数字的颜色
    textSize: 9, // 显示文字的大小
    maxZoom:10,
    range: [0, 10000]
  }])
  var panoId=''


  // 显示地图的最佳级别
  // eslint-disable-next-line
  // MAP.map.setViewport(zoomArr)
}

function addressSite(data) {
  // eslint-disable-next-line
  var p_data = data
  var namesearchId = 'namesearch_' + p_data.id;

  MAP.map.clearOverLays()
    if(MAP.MarkerClusterer!=null)
    {
      MAP.MarkerClusterer.clearMarkers()
    }
    // eslint-disable-next-line
      MAP.Marker= new T.Marker(new T.LngLat(p_data.x, p_data.y), {
      icon: icon
    })
    MAP.Marker.id = 'namesearch_' + p_data.id
    MAP.Marker.pointId = p_data.id
    // eslint-disable-next-line
    MAP.Marker.attributes = p_data
    MAP.Marker.addEventListener('click', overlay_style)
    MAP.Marker.addEventListener('mouseover', Mark_Mouseover)
    MAP.Marker.addEventListener('mouseout', Mark_Mouseout)

    // 向地图上添加标注
    // eslint-disable-next-line
    MAP.map.addOverLay(MAP.Marker)
    overlay_style(MAP.Marker)
    // eslint-disable-next-line
    //MAP.map.removeOverLay(marker)
    MAP.map.centerAndZoom(new T.LngLat(p_data.x, p_data.y), MAP.map.getZoom());
}

// 地图弹出内容
// eslint-disable-next-line
function overlay_style(e) {
  // eslint-disable-next-line
  if (typeof(e.target) == 'undefined') {
    e.target = e
  }

  if (MAP.InfoWinName) {
     MAP.map.removeOverLay(MAP.InfoWinName);
     MAP.InfoWinName = null;
  }

  var x = parseFloat(e.target.attributes.x)
  var y = parseFloat(e.target.attributes.y)

  MAP.map.centerAndZoom(new T.LngLat(x, y), MAP.map.getZoom());


  setTimeout(function(){
    //判断
    if (MAP.infoWin.attributes != null) {
      if (MAP.infoWin.attributes.id == e.target.pointId && MAP.infoWin.attributes.isClick) {
        MAP.infoWin.attributes.isClick = false
        MAP.infoWin.attributes.id = 0
        MAP.map.removeOverLay(MAP.infoWin)
        return
      }
    }

    // eslint-disable-next-line
    var recordName = '<div class=\'title oneRow\'><span  title=\'' + e.target.attributes.name + '\'>' + e.target
      .attributes.name + '</span></div>'

    var recordAddress = '<div class="oneRow"><span>地址：</span> <span>' + (e.target.attributes.address || '暂无') +
      '</span></div>'
    // eslint-disable-next-line
    /*
     if (e.target.attributes.address == '' || typeof (e.target.attributes.address) == 'undefined') {
        recordAddress = ''
      }
      */
    var recordPhone = '<div class="oneRow"><span>电话：</span> <span>' + (e.target.attributes.phone || '暂无') +
      '</span></div>'
    // eslint-disable-next-line
    /*
    if (e.target.attributes.phone == '' || typeof (e.target.attributes.phone) == 'undefined') {
       recordPhone = ''
     }
     */
    let recordPanoUrl = ''
    if (e.target.attributes.panoUrl) {
      recordPanoUrl = '<a target="_blank" href="' + e.target.attributes.panoUrl + '" class="icon-img img-map-see"></a>'
    }
    /*
    let recordGood = ''
    let recordShare = ''
    if (e.target.attributes.share) {
      recordShare = '<span class="img-map-share"><i class="icon-img"></i>' + e.target.attributes.share + '</span>'
    }
    if (e.target.attributes.good) {
      recordGood = '<span class="img-map-good"><i class="icon-img"></i>' + e.target.attributes.good + '</span>'
    }
    */

    var sContent = '<div class=\'info_container\' ' +
      'style=\'background-image: url(' + e.target.attributes.imgSrc + ');\'>' + recordName + recordPanoUrl +
      ' <div class=\'props\'>' + recordAddress + recordPhone +
      // '   <div class="oneRow share-good">' + recordGood + recordShare + '</div>' +
      ' </div>' +
      '</div>'

    MAP.infoWin.attributes = e.target.attributes
    MAP.infoWin.attributes.id = e.target.pointId


    // eslint-disable-next-line
    MAP.infoWin.setContent(sContent)
    // eslint-disable-next-line
    MAP.infoWin.setLngLat(new T.LngLat(x, y))
    // eslint-disable-next-line
    MAP.infoWin.setOffset(new T.Point(-7, 5))
    // eslint-disable-next-line
    e.target.openInfoWindow(MAP.infoWin)
    MAP.infoWin.attributes.isClick = true
    //MAP.map.addOverLay(MAP.infoWin);
  },10)

}

function Mark_Mouseover(e){
 // eslint-disable-next-line
  if (typeof(e.target) == 'undefined') {
    e.target = e
  }

  var x = parseFloat(e.target.attributes.x)
  var y = parseFloat(e.target.attributes.y)
  //判断
  if (MAP.infoWin.attributes != null) {
    if (MAP.infoWin.attributes.id == e.target.pointId && MAP.infoWin.attributes.isClick) {
       return
    }
  }
  // eslint-disable-next-line
  var recordName = '<p class=\'infowindow-hover-name oneRow\'><span  title=\'' + e.target.attributes.name + '\'>' + e.target
    .attributes.name + '</span></p>'

  var sContent = '<div class=\'infowindow-hover\' >' + recordName  +
    ' <div class=\'props\'></div>' +
    '</div>'

  //创建信息窗口对象
  MAP.InfoWinName = new T.InfoWindow();
  MAP.InfoWinName.setLngLat(new T.LngLat(x, y));
  MAP.InfoWinName.setOffset(new T.Point(-7, -12))
  //设置信息窗口要显示的内容
  MAP.InfoWinName.setContent(sContent);
  //向地图上添加信息窗口
  MAP.map.addOverLay(MAP.InfoWinName);


}

function Mark_Mouseout(e)
{
  if (MAP.InfoWinName) {
    MAP.map.removeOverLay(MAP.InfoWinName);
    MAP.InfoWinName = null;
 }
}

function mapFun(url, params, bool) {
  if (bool) {
    if (location.href.indexOf('reloaded') === -1) {
      // location.href = location.href + 'reloaded' // 没有添加标记
      // location.reload() // 刷新
    }
  }
  if (params.page === 1) {
    pointdata = []
  }
  return new Promise((resolve, reject) => {
    try {
      httpAjax.getAjax(url, params).then(function(data) {
        if (data.code === 1) {
          let newData = JSON.parse(JSON.stringify(data.data))
          pointdata = pointdata.concat(newData)
          //ShowSearchPoint(pointdata)
          resolve(data)
        }
      }, function(err) {
        reject(err)
        console.log(err)
      })
    } catch (err) {
      console.log(err)
    }
  })
}

/**
 * 移动地图 返回对应的地址信息
 * @param callback
 */
function moveMap(callback) {

  /* eslint-disable */
  MAP.map.addEventListener("moveend", function (e) {
    var x = MAP.map.getCenter().getLng();
    var y = MAP.map.getCenter().getLat();
    var zoom = MAP.map.getZoom();
    var getCityUrl = "http://api.tianditu.gov.cn/geocoder?" + "postStr={'lon':" + x + ",'lat':" + y + ",'ver':1}&type=geocode&tk=" + MAP.tk;

    let id=(MAP.infoWin&&MAP.infoWin.attributes&&MAP.infoWin.attributes.id?MAP.infoWin.attributes.id:'');

    $.getJSON(getCityUrl, function (data) {
      if (data.msg == "ok") {
        if(id){
          data.result.id=id;
          MAP.infoWin.attributes.id=''
        }else {
          data.result.id=''
        }
        callback(data.result)
      }
    });
  });
}
/**
 * 拖拽地图 返回就近城市
 * @param cityData
 * @param moveData
 * @param mapLevel
 */
function moveMapBackCity (cityData, moveData, mapLevel) {
  let backCity = '';
  let addressComponent = moveData.addressComponent;

  if(cityData&&cityData.length){
    for (var i = 0; i < cityData.length; i++) {
      let cityPac = cityData[i].cityPac
      if(cityPac == addressComponent.city_code){
        backCity = cityData[i]
        // if(countyIndex){
        for (let j = 0; j < cityData[i].child.length; j++) {
          let countyPac = cityData[i].child[j].cityPac
          if (countyPac == addressComponent.county_code) {
            let c = cityData[i].child[j]
            if (c.mapLevel <= mapLevel) {
              backCity = c
            }
          }
        }
        // }
        break;
      }
    }
  }
  return backCity
}

export default {
  mapFun: mapFun,
  addressSite: addressSite,
  ShowSearchPoint: ShowSearchPoint,
  moveMap: moveMap,
  moveMapBackCity: moveMapBackCity
}



// WEBPACK FOOTER //
// ./src/common/map.js